// apps/codeframe/src/chrome/timeline/useTrackHighlight.ts
import { create } from 'zustand';
import { useCanvasStore } from '../../store/canvas-store';
import type { LayerRef } from '../../store/types';

/** Transient hover ref, separate from layerSelection so hovering a row never
 *  steals a selection. LayerOverlay renders BOTH: selection solid, hover dashed. */
export const useHoverLayer = create<{ ref: LayerRef | null }>(() => ({ ref: null }));

export function hoverHighlight(frameId: string, cfNodeId: string): void {
  useHoverLayer.setState({ ref: { frameId, cfNodeId } });
}

export function clearHoverHighlight(): void {
  useHoverLayer.setState({ ref: null });
}

/** Clicking a track header makes the canvas show which node it animates. */
export function selectTrackTarget(frameId: string, cfNodeId: string): void {
  useCanvasStore.getState().setLayerSelection({ frameId, cfNodeId });
}
